import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <footer className="section-t-space background-blue-theme">
        <div className="container-fluid-lg">
          <div className="main-footer pt-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <a href="https://www.zantuslifesciences.in/" target="_blank" rel="noopener noreferrer">
                  <img
                    src="../assets/images/Footerlogo.png"
                    className="blur-up lazyload logo-size-footer"
                    alt=""
                  />
                </a>
                <div className="mt-2">
                  <a href="https://www.zantuslifesciences.in/" target="_blank" rel="noopener noreferrer">
                    Zantus Lifesciences LLP
                  </a>
                </div>
              </div>
              <div className="social-icons ">
                <div className="text-content font-xsm text-white">Stay connected :</div>
                <div className="d-flex justify-content-between align-items-center ">
                  <div className="social-icons my-2 d-flex align-items-center gap-2 ">
                    {/* <div className="circular_background_icons ">
                      <a href="/">
                        <i className="fab fa-facebook"></i>
                      </a>
                    </div> */}

                    {/* <div className="circular_background_icons">
                      <a href="/">
                        <FontAwesomeIcon className="x-icon" icon={faXTwitter} />
                      </a>
                    </div> */}

                    {/* <div className="circular_background_icons">
                      <a href="/">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </div> */}
                    <div style={{textAlign:"center"}} className="circular_background_icons">
                      <a href="/">
                        <i className="fab fa-linkedin"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-5 mb-2 ">
                <div className="footer-contain">
                  <p className="w-75 mb-4 font-xsm text-white">
                  Zantus is committed to provide high-quality, science-backed nutrition wellness products and services, 
                  fostering a healthier & vibrant world.
                  </p>
                </div>
              </div>

              <div className="col-xl-5 mb-2">
                <div className="footer-contain">
                  <ul>
                    <li>
                      <Link to="/privacy" className="text-content  font-xsm text-white">
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/terms-and-conditions" className="text-content  font-xsm text-white">
                        Terms And Condition
                      </Link>
                    </li>

                    <li>
                      <a href="/press" className="text-content  font-xsm text-white">
                        Press
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-2 mb-2">
                <div className="footer-contain mb-4 font-xsm text-white">
                  <ul>
                    {/* <li>
                      <a href="/" className="text-content font-xsm text-white text-white">
                        Location
                      </a>
                    </li> */}
                    <li>
                      <a href="/contact-us" className="text-content  font-xsm text-white">
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row margin_footer_downloadApp mb-4">
            </div>

            <div className="text-center font-xs pb-2">
              © Reducarb 2025, All Rights Reserved by Zantus Lifesciences LLP. Developed By{" "}
              <a
                href="https://www.aarambhstudios.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Aarambh Studios
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
